module.exports = __webpack_public_path__ + "static/media/image6.2356d34d.JPG";